/**
 * useCreatorFees — Fetches accumulated fees and claim history for a token.
 *
 * Requires wallet connection and access token.
 * Only callable for tokens owned by the authenticated creator.
 *
 * Story 6.2 — Task 2.3
 */

import { useQuery } from "@tanstack/react-query";
import { creatorApi } from "../../lib/api";
import { useWallet } from "../use-wallet";
import { creatorKeys } from "./query-keys";

export function useCreatorFees(tokenId: string) {
	const { address, getAccessToken } = useWallet();

	return useQuery({
		queryKey: creatorKeys.fees(tokenId, address),
		queryFn: async () => {
			const accessToken = await getAccessToken();
			if (!accessToken) {
				// eslint-disable-next-line no-restricted-syntax -- TanStack Query requires thrown errors
				throw new Error("No access token available");
			}
			const response = await creatorApi.getTokenFees(tokenId, accessToken, address);
			return response.data;
		},
		enabled: !!address && !!tokenId,
		staleTime: 60_000,
	});
}
